import styled from "styled-components";

export const $StartPartner = styled.div`
`;